import { render, staticRenderFns } from "./medicalservice.vue?vue&type=template&id=34593f9e&scoped=true&"
import script from "./medicalservice.vue?vue&type=script&lang=js&"
export * from "./medicalservice.vue?vue&type=script&lang=js&"
import style0 from "./medicalservice.vue?vue&type=style&index=0&id=34593f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34593f9e",
  null
  
)

export default component.exports